import {Form} from 'nf-ui'
import React from 'react'
import {Column, Row} from '~/pages/Adminland/PhotoCollection/ListComponents'
import {ProfileSelectState} from './useProfileSelect'

function Header<ProfileType>({multiselect}: {multiselect: ProfileSelectState<ProfileType>}) {
    const {toggleAll, checkedAll} = multiselect
    return (
        <Row>
            <Column>
                <Form.Group name="name">
                    <Form.Checkbox checked={checkedAll} onChange={toggleAll} bold label="Name" />
                </Form.Group>
            </Column>
        </Row>
    )
}

export {Header}
